// 1. Enum con los códigos de cada tipo de pago
export enum EPayType {
  EPAYTYPE01 = 'EPAYTYPE01',
  EPAYTYPE02 = 'EPAYTYPE02',
  EPAYTYPE03 = 'EPAYTYPE03',
}

// 2. Interfaces
export interface EPayFile {
  type: EPayType
  code: string
  slugFile: string
  name: string
  information: string
  url: string
}

export interface EPayTypeInfo {
  code: EPayType
  name: string
  slug: string
}

// 3. Definición de los tipos (sin archivos)
export const ePayTypes: EPayTypeInfo[] = [
  {
    code: EPayType.EPAYTYPE01,
    name: 'Pequeño Contribuyente',
    slug: 'pequeno_contribuyente',
  },
  {
    code: EPayType.EPAYTYPE02,
    name: 'Comerciante Individual',
    slug: 'comerciante_individual',
  },
  { code: EPayType.EPAYTYPE03, name: 'Sociedad Anónima', slug: 'sociedad_anonima' },
]

// 4. Plantillas comunes y extra para generar archivos
interface FileTemplate {
  suffix: string
  slugFile: string
  name: string
  information: string
}

const COMMON_FILE_TEMPLATES: FileTemplate[] = [
  {
    suffix: 'F01',
    slugFile: 'rtu',
    name: 'RTU',
    information:
      'Registro de Contribuyentes Únicos es una iniciativa de la Superintendencia de Administración Tributaria (SAT) para identificar a personas y entidades que realizan actividades económicas en el país. Proporciona un número único de identificación para cumplir con las obligaciones fiscales, como emitir facturas y declarar impuestos. Su inscripción es obligatoria para operar legalmente.',
  },
  {
    suffix: 'F02',
    slugFile: 'dpi_adelante',
    name: 'DPI Adelante',
    information:
      'Documento Personal de Identificación emitida por el RENAP, tomar en cuenta la fecha de vencimiento y tener la fotografia de adelante y atras legible',
  },
  {
    suffix: 'F03',
    slugFile: 'dpi_atras',
    name: 'DPI Atras',
    information:
      'Documento Personal de Identificación emitida por el RENAP, tomar en cuenta la fecha de vencimiento y tener la fotografia de adelante y atras legible',
  },
  {
    suffix: 'F04',
    slugFile: 'cuenta_bancaria',
    name: 'Encabezado de Cuenta Bancaria o Cheque anulado',
    information:
      'Documento o boleta de pago que indique el numero de cuenta completo, banco al que pertenece, nombre de la cuenta, y tipo de cuenta si es monetaria o ahorro con la moneda GTQ o USD',
  },
  {
    suffix: 'F05',
    slugFile: 'Selfie_DPI',
    name: 'Selfie con DPI en mano',
    information: '',
  },
  {
    suffix: 'F06',
    slugFile: 'factura_servicio',
    name: 'Factura de servicios (Agua, Luz o Teléfono)',
    information:
      'Comprobante de algun pago de luz, agua o telefono local, para verificar la dirección de la empresa',
  },
]

const EXTRA_FILE_TEMPLATES: Record<EPayType, FileTemplate[]> = {
  [EPayType.EPAYTYPE01]: [
    {
      suffix: 'F07',
      slugFile: 'dpi_foto',
      name: 'Fotografía que aparece en DPI',
      information: 'Fotografía que aparece en DPI',
    },
  ],
  [EPayType.EPAYTYPE02]: [
    {
      suffix: 'F07',
      slugFile: 'patente_comercio',
      name: 'Patente de Comercio',
      information:
        'Es un documento legal que autoriza a una persona o entidad a ejercer actividades comerciales. Es emitida por la municipalidad correspondiente. Es esencial para operar un negocio legalmente y varía según el tamaño y tipo del comercio.',
    },
    {
      suffix: 'F08',
      slugFile: 'dpi_foto',
      name: 'Fotografía que aparece en DPI',
      information: 'Fotografía que aparece en DPI',
    },
  ],
  [EPayType.EPAYTYPE03]: [
    {
      suffix: 'F07',
      slugFile: 'patente_comercio',
      name: 'Patente de Comercio',
      information:
        'Es un documento legal que autoriza a una persona o entidad a ejercer actividades comerciales. Es emitida por la municipalidad correspondiente. Es esencial para operar un negocio legalmente y varía según el tamaño y tipo del comercio.',
    },
    {
      suffix: 'F08',
      slugFile: 'dpi_foto',
      name: 'Fotografía que aparece en DPI',
      information: 'Fotografía que aparece en DPI',
    },
  ],
}

// 5. Generar el mapa de archivos por tipo
export const ePyFilesByType: Record<EPayType, EPayFile[]> = Object.fromEntries(
  ePayTypes.map(({ code }) => [
    code,
    [...COMMON_FILE_TEMPLATES, ...(EXTRA_FILE_TEMPLATES[code] || [])].map(
      ({ suffix, slugFile, name, information }) => ({
        type: code,
        code: `${code}_${suffix}`,
        slugFile,
        name,
        information,
        url: '',
      }),
    ),
  ]),
) as Record<EPayType, EPayFile[]>

// 6. Función para extraer archivos según tipo
export function getFilesByType(type: EPayType): EPayFile[] {
  return ePyFilesByType[type] ?? []
}
